module.exports = __webpack_public_path__ + "static/media/youtube.e93047dd.svg";